module.exports = __webpack_public_path__ + "img/minutes.0bc6bf49.svg";